const model = {
    name: 'RecommendationsRecipe',
    properties: {
        id: {},
        version: {},
    },
};
export default model;
